import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { financeClient } from '#pplx_generated/typespec/rest/finance/client.js';
export const getQuote = async (symbol) => {
    const { data, error, response } = await financeClient.GET('/rest/finance/quote/{market_identifier}', 'automations/quote', {
        params: {
            path: {
                market_identifier: symbol,
            },
        },
    });
    if (error) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data;
};
export const getQuoteKey = (symbol) => ['automations/quote', symbol];
//# sourceMappingURL=getQuote.js.map